import {createContext, PropsWithChildren, useMemo} from 'react';
import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from '../ChekinSDK';
import {QUERY_CACHE_KEYS,IpDetails} from '@chekin/core';
import {API} from '@chekin/api';

type ContextProps = {
  ipDetails?: IpDetails;
};

const IpDetailsContext = createContext<ContextProps>({});

function IpDetailsProvider(props: PropsWithChildren) {
  const {isSuccessSDK} = useChekinSDK();
  const {data} = useQuery<IpDetails>({
    queryKey: [QUERY_CACHE_KEYS.ipDetails],
    queryFn: () => API.auth.getIpDetails(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: isSuccessSDK,
  });

  const value: ContextProps = useMemo(
    () => ({
      ipDetails: data,
    }),
    [data],
  );

  return <IpDetailsContext.Provider {...props} value={value} />;
}

export {IpDetailsProvider, IpDetailsContext, type ContextProps};
